import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

export type ResetFiltersDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
};

export const ResetFiltersDialog = ({
  open,
  onClose,
  onConfirm,
  loading = false,
}: ResetFiltersDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth disableScrollLock>
      <DialogTitle>Clear all filters?</DialogTitle>
      <DialogContent>
        <DialogContentText>This action will remove all applied filters.</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error" variant="outlined" disabled={loading}>
          Cancel
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained" disabled={loading} autoFocus>
          {loading ? 'Resetting...' : 'Reset'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
